import { isNil } from '@lucidlink/tscore';
import { Logging } from '#common/logging';
import { withStats } from '#common/stats';
import { InvalidStateError } from '#common/types';
import { NodeStats } from './types';
export const createNode = (proxy, storage) => {
    return new NodeImpl(proxy, storage);
};
export const NODE_INDEX_KEY = 'nodeId';
class NodeImpl {
    proxy;
    storage;
    nodeIndex;
    nodeIndexKey = NODE_INDEX_KEY;
    log = Logging.getLogger('Node');
    statistics = new NodeStats(this.log);
    constructor(proxy, storage) {
        this.proxy = proxy;
        this.storage = storage;
        this.nodeIndex = storage?.get(this.nodeIndexKey);
    }
    async getNodeIndex() {
        if (!isNil(this.nodeIndex)) {
            return this.nodeIndex;
        }
        if (isNil(this.proxy)) {
            throw new InvalidStateError('No connection to lucid hub');
        }
        this.nodeIndex = await withStats(this.statistics.fetchNodeIndex, async () => {
            return await this.proxy.fetchNodeIndex();
        });
        this.storage?.put(this.nodeIndexKey, this.nodeIndex);
        return this.nodeIndex;
    }
    stats() {
        return this.statistics;
    }
}
